//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    export default{
        name:'bb_form_b',
        data(){
            return{
                child_birth:'',
                get_host:host.host,
                form:{
                    room:'',
                    card:'',
                    sex:'',
                    baby_id:'',
                    name:'',
                    momName:'',
                    date:'',
                    birtherDay:'',
                    temperature:'',
                    weight:'',
                    nursing:'1',
                    bath:'1',
                    swimming:'',
                    touch:'',
                    massage:'',
                    spa:'0',
                    other:'',
                    signature:'',
                    shifts:''
                },
                showSignature:false,
                option:{
                    penColor:"rgb(0, 0, 0)"
                },
                baby_list:[],
            }
        },
        created(){
            this.get_baby_list()
            this.apiMemberInfo()
            if(this.$route.query.list_id){
                this.apiDetail()
            }else{
                this.form.other = '母乳喂养、母婴同室'
            }
        },
        methods:{
            GetNumberOfDays(date1,date2){//获得天数
                //date1：开始日期，date2结束日期
                var a1 = Date.parse(new Date(date1));
                var a2 = Date.parse(new Date(date2));
                var day = parseInt((a2-a1)/ (1000 * 60 * 60 * 24));//核心：时间戳相减，然后除以天数
                return day
            },
            change_date(value){
                console.log(this.child_birth)
                this.apiMemberInfo(value)
            },
            checkerChange(value){
                for(let item of this.baby_list){
                    if(item.id == value){
                        if(item.live_time == '0'){
                            this.$vux.toast.show({
                                type: 'cancel',
                                text: item.name+'暂未入住',
                            })
                            return
                        }
                        this.form.card = item.hand_card
                        this.form.sex = item.sex == "1" ? "男" : "女"
                        this.form.name = item.name
                        this.form.birtherDay = item.birth_day
                    }
                }
            },
            get_baby_list (){
                let params = {
                    token: this.$cookie.get('token'),
                    maternal_info_id: this.$route.query.id
                }
                Api.monthLiveApi.babyList(params).then ( res => {
                    console.info(res)
                    if(res.errcode == 1){
                        this.baby_list = res.data
                        // this.form.baby_id = res.data[0].id
                        // this.form.sex = res.data[0].sex == "1" ? "男" : "女"
                    }else{
                        this.$vux.toast.show({
                            type: 'cancel',
                            text: res.errinfo,
                        })
                    }
                })
            },
            //时间戳转日期格式    
            formatDateTime(inputTime) {  
                var date = new Date(parseInt(inputTime)*1000)
                var y = date.getFullYear() 
                var m = date.getMonth() + 1  
                m = m < 10 ? ('0' + m) : m; 
                var d = date.getDate()
                d = d < 10 ? ('0' + d) : d
                var h = date.getHours()
                h = h < 10 ? ('0' + h) : h
                var minute = date.getMinutes()
                var second = date.getSeconds()
                minute = minute < 10 ? ('0' + minute) : minute 
                second = second < 10 ? ('0' + second) : second
                return y + '-' + m + '-' + d
            },
            //请求用户基本信息
            apiMemberInfo(value){
                let params = {
                    token: this.$cookie.get('token'),
                    maternal_info_id: this.$route.query.id
                }
                Api.checkRoomApi.memberInfo(params).then ( res => {
                    console.info(res)
                    if(res.errcode == 1){
                        this.form.momName = res.data.name
                        this.form.room = res.data.room_name
                        this.child_birth = this.formatDateTime(res.data.child_birth)
                        if(value){
                            let day = this.GetNumberOfDays(this.child_birth,value)+1
                            this.form.birtherDay = day
                        }
                    }else{
                        this.$vux.toast.show({
                            type: 'cancel',
                            text: res.errinfo,
                        })
                    }
                })
            },
            save(){
                let signature ='signature1'
                console.info(this.$refs[signature])
                let png = this.$refs[signature].save()
                this.form.signature = encodeURI(png)
                this.showSignature = true
            },
            edit(){
                this.showSignature = false
                this.form.signature = ''
            },
            clear(){
                let signature ='signature1'
                let refs = this.$refs[signature].clear()
                this.form.signature = ''
            },
            //请求详情数据
            apiDetail(){
                let params = {
                    token: this.$cookie.get('token'),
                    id:this.$route.query.list_id
                }
                this.$vux.loading.show({
                    text: '正在加载'
                })
                Api.bbFormApi.getBabyCareOperaFind(params).then ( res => {
                    console.info(res)
                    if(res.errcode == 200){
                        let data = res.data
                        this.form.room = data.room_number
                        this.form.card = data.id_card
                        this.form.name = data.baby_name
                        this.form.baby_id=data.baby_id
                        this.form.sex = data.baby_gender
                        this.form.momName = data.mom_name
                        this.form.date = data.cat_date
                        this.form.birtherDay = data.birth_day_num
                        this.change_date(data.cat_date)
                        this.form.temperature = data.temperature
                        this.form.weight = data.weight
                        this.form.nursing = data.umb_protection_num
                        this.form.bath = data.take_shower_num
                        this.form.swimming = data.swim_num
                        this.form.touch = data.touch_num
                        this.form.massage = data.massage_num
                        this.form.spa = data.spa_num
                        this.form.other = data.other_situation
                        this.form.signature = data.opera_name.indexOf(this.get_host) != -1 ? data.opera_name : this.get_host+data.opera_name
                        this.form.shifts = data.shifts
                        this.showSignature = true
                        this.$vux.loading.hide()
                    }else{
                        this.$vux.loading.hide()
                        this.$vux.toast.show({
                            type: 'cancel',
                            text: res.errinfo,
                        })
                    }
                })
            },
            //请求添加数据
            apiAddForm(){
                let babyName = ''
                for(let item of this.baby_list){
                    if(item.id == this.form.baby_id){
                        babyName = item.name
                    }
                }
                let params = {
                    token: this.$cookie.get('token'),
                    number_id:this.$cookie.get('id'),
                    maternal_info_id: this.$route.query.id,
                    store_id:this.$cookie.get('store_id'),
                    room_number:this.form.room,
                    id_card:this.form.card,
                    baby_name:babyName,
                    baby_id:this.form.baby_id,
                    baby_gender:this.form.sex,
                    mom_name:this.form.momName,
                    cat_date:this.form.date,
                    birth_day_num:this.form.birtherDay,
                    massage_num:this.form.massage,
                    temperature:this.form.temperature,
                    weight:this.form.weight,
                    umb_protection_num:this.form.nursing,
                    take_shower_num:this.form.bath,
                    swim_num:this.form.swimming,
                    touch_num:this.form.touch,
                    spa_num:this.form.spa,
                    other_situation:this.form.other,
                    opera_name:this.form.signature,
                    shifts: this.form.shifts
                }
                this.$vux.loading.show({
                    text: '正在加载'
                })
                Api.bbFormApi.addBabyCareOperaData(params).then ( res => {
                    console.info(res)
                    if(res.errcode == 200){
                        this.$vux.loading.hide()
                        this.$router.replace({
                            path:'/success',
                            query:{
                                id:this.$route.query.id,
                                form_id:this.$route.query.form_id,
                                tabVal:this.$route.query.tabVal,
                                name : 'bb_form_f',
                            }
                        })
                    }else{
                        this.$vux.loading.hide()
                        this.$vux.toast.show({
                            type: 'cancel',
                            text: res.errinfo,
                        })
                    }
                })
            },
            //请求更新数据
            apiUpdateForm(){
                let params = {
                    token: this.$cookie.get('token'),
                    id:this.$route.query.list_id,
                    number_id:this.$cookie.get('id'),
                    maternal_info_id: this.$route.query.id,
                    store_id:this.$cookie.get('store_id'),
                    room_number:this.form.room,
                    id_card:this.form.card,
                    baby_name:this.form.name,
                    baby_id:this.form.baby_id,
                    baby_gender:this.form.sex,
                    mom_name:this.form.momName,
                    massage_num:this.form.massage,
                    cat_date:this.form.date,
                    birth_day_num:this.form.birtherDay,
                    temperature:this.form.temperature,
                    weight:this.form.weight,
                    umb_protection_num:this.form.nursing,
                    take_shower_num:this.form.bath,
                    swim_num:this.form.swimming,
                    touch_num:this.form.touch,
                    spa_num:this.form.spa,
                    other_situation:this.form.other,
                    opera_name:this.form.signature.indexOf(this.get_host) != -1 ? this.form.signature.replace(this.get_host,'') : this.form.signature,
                    shifts: this.form.shifts
                }
                console.info(params)
                this.$vux.loading.show({
                    text: '正在加载'
                })
                Api.bbFormApi.updateBabyCareOperaData(params).then ( res => {
                    console.info(res)
                    if(res.errcode == 200){
                        this.$vux.loading.hide()
                        this.$router.replace({
                            path:'/success',
                            query:{
                                id:this.$route.query.id,
                                form_id:this.$route.query.form_id,
                                tabVal:this.$route.query.tabVal,
                                name : 'bb_form_f',
                            }
                        })
                    }else{
                        this.$vux.loading.hide()
                        this.$vux.toast.show({
                            type: 'cancel',
                            text: res.errinfo,
                        })
                    }
                })
            },
            edit(){
                this.showSignature = false
            },
            submitForm(){
                let form = this.form
                if(form.card == ''){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请输入手卡号',
                    })
                    return
                }
                if(form.baby_id == ''){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请选择宝宝',
                    })
                    return
                }
                if(form.date == ''){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请选择日期',
                    })
                    return
                }
                if(form.birtherDay == ''){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请输入出生天数',
                    })
                    return
                }
                if(form.temperature == ''){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请输入体温',
                    })
                    return
                }
                if(form.weight == ''){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请输入体重',
                    })
                    return
                }
                if(form.nursing == ''){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请输入脐护',
                    })
                    return
                }
                if(form.bath == ''){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请输入洗澡',
                    })
                    return
                }
                if(form.swimming == ''){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请输入游泳',
                    })
                    return
                }
                if(form.touch == ''){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请输入抚触',
                    })
                    return
                }
                if(form.massage == ''){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请输入早教',
                    })
                    return
                }
                if(form.spa == ''){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请输入SPA',
                    })
                    return
                }
                if(form.other == ''){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请输入其他情况',
                    })
                    return
                }
                if(form.shifts == ''){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请选择班次',
                    })
                    return
                }
                if(form.signature == ''){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请输入签名',
                    })
                    return
                }
                // 判断宝宝是否入住
                let time = 0
                if(this.baby_list.length){
                    for(let item of this.baby_list){
                        if(item.id == this.form.baby_id){
                            time = item.live_time
                        }
                    }
                }
                if(time == '0'){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '该宝宝暂未入住',
                    })
                    return
                }
                if(this.$route.query.list_id){
                    console.info("请求更新数据")
                    this.apiUpdateForm()
                }else{
                    this.apiAddForm()
                }
            }
        }
    }



// WEBPACK FOOTER //
// ./src/components/bb_form_f.vue